<template>
  <section class="cemop-section">
    <div class="container py-5">
      <!-- Header Card -->
      <div class="cemop-header-card">
        <div class="cemop-header-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
        </div>
        <h1 class="cemop-title">CEMOFI 2026</h1>
        <h2 class="cemop-subtitle">{{ config.titulo }}</h2>
        <p class="cemop-decreto">Decreto 000185 – MPTeI 2026</p>
      </div>

      <!-- Alert Card -->
      <div class="cemop-alert-card">
        <div class="alert-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div class="alert-content">
          <h3 class="alert-title">ATENCIÓN</h3>
          <p class="alert-text">
            Es muy importante completar toda la documentación y adjuntar los archivos exigidos por la normativa vigente.
          </p>
          <p class="alert-text mb-0">
            La información proporcionada en este formulario tiene carácter de <strong>declaración jurada</strong>,
            asumiendo la responsabilidad correspondiente en caso de falsedad o inexactitud.
            La detección de errores podrá ocasionar el <strong>rechazo de la solicitud</strong>.
          </p>
        </div>
      </div>

      <!-- Download Buttons -->
      <div class="cemop-buttons-grid">
        <a :href="config.excelUrl" class="cemop-download-btn cemop-download-btn-primary" target="_blank">
          <div class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <path d="M8 13h2"></path>
              <path d="M8 17h2"></path>
              <path d="M14 13h2"></path>
              <path d="M14 17h2"></path>
            </svg>
          </div>
          <div class="btn-content">
            <span class="btn-label">Descarga Excel</span>
            <span class="btn-description">{{ config.excelDescripcion }}</span>
          </div>
          <div class="btn-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="7 10 12 15 17 10"></polyline>
              <line x1="12" y1="15" x2="12" y2="3"></line>
            </svg>
          </div>
        </a>

        <a :href="config.formularioUrl" class="cemop-download-btn cemop-download-btn-secondary" target="_blank">
          <div class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </div>
          <div class="btn-content">
            <span class="btn-label">Formulario de Registro</span>
            <span class="btn-description">{{ config.formularioDescripcion }}</span>
          </div>
          <div class="btn-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CemopView",
  props: {
    tipo: {
      type: String,
      default: 'registro', // 'registro' o 'incremento'
      validator: (value) => ['registro', 'incremento'].includes(value)
    }
  },
  computed: {
    config() {
      const configs = {
        registro: {
          titulo: 'Registro de Empresas Industriales de San Juan 2026',
          excelUrl: 'https://produccion.sanjuan.gob.ar/pdf/Excel%20para%20calculo%20promedio%20de%20trabajadores%20afectados%20a%20la%20actividad%20industrial%20-CEMOFI%202026%20(2).xlsx',
          excelDescripcion: 'Cálculo promedio de trabajadores afectados a la actividad industrial',
          formularioUrl: 'https://forms.gle/oiX1q17AVfPB4k3w8',
          formularioDescripcion: 'Formulario de Registro de Empresas Industriales'
        },
        incremento: {
          titulo: 'Actualización por Incremento de nómina 2026',
          excelUrl: 'https://produccion.sanjuan.gob.ar/pdf/Excel%20para%20calculo%20de%20incremento%20de%20trabajadores%20afectados%20a%20la%20actividad%20industrial%20-CEMOFI%202026.xlsx',
          excelDescripcion: 'Cálculo de incremento de trabajadores afectados a la actividad industrial',
          formularioUrl: 'https://forms.gle/HK5zynZXHWUouxg88',
          formularioDescripcion: 'Formulario de actualización por incremento de nómina 2026'
        }
      };
      return configs[this.tipo];
    }
  }
};
</script>

<style scoped>
.cemop-section {
  min-height: calc(100vh - 300px);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  position: relative;
  overflow: hidden;
}

.cemop-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, rgb(255, 130, 0), rgb(220, 145, 27), rgb(255, 130, 0));
}

/* Header Card */
.cemop-header-card {
  background: linear-gradient(135deg, rgb(29, 37, 45) 0%, rgb(45, 55, 72) 100%);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  margin-bottom: 2rem;
  box-shadow: 0 20px 40px rgba(29, 37, 45, 0.2);
  position: relative;
  overflow: hidden;
}

.cemop-header-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.5;
}

.cemop-header-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, rgb(255, 130, 0), rgb(220, 145, 27));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5rem;
  position: relative;
  z-index: 1;
}

.cemop-header-icon svg {
  color: white;
}

.cemop-title {
  font-family: "Ubuntu-Bold", system-ui, sans-serif;
  font-size: 2.5rem;
  color: white;
  margin-bottom: 0.5rem;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.cemop-subtitle {
  font-family: "Ubuntu-Medium", system-ui, sans-serif;
  font-size: 1.25rem;
  color: rgb(255, 130, 0);
  margin: 0 0 0.5rem 0;
  position: relative;
  z-index: 1;
}

.cemop-decreto {
  font-family: "Ubuntu-Regular", system-ui, sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  position: relative;
  z-index: 1;
}

/* Alert Card */
.cemop-alert-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.cemop-alert-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.alert-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  background: linear-gradient(135deg, rgba(255, 130, 0, 0.1), rgba(220, 145, 27, 0.1));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-icon svg {
  color: rgb(255, 130, 0);
}

.alert-content {
  flex: 1;
}

.alert-title {
  font-family: "Ubuntu-Bold", system-ui, sans-serif;
  font-size: 1.1rem;
  color: rgb(193, 0, 0);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.alert-text {
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.alert-text strong {
  color: rgb(29, 37, 45);
}

/* Download Buttons */
.cemop-buttons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.cemop-download-btn {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border-radius: 12px;
  text-decoration: none !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.cemop-download-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.cemop-download-btn:hover::before {
  left: 100%;
}

.cemop-download-btn-primary {
  background: #413e43; 
  color: #ffffff;
  transition: all 0.3s ease;
}

.cemop-download-btn-primary:hover {
  background: #2e2c30; 
  transform: translateY(-4px);
}

.cemop-download-btn-secondary {
  background: #FF8200;
}

.cemop-download-btn-secondary:hover {
transform: translateY(-4px);
}

.btn-icon {
  width: 56px;
  height: 56px;
  min-width: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon svg {
  color: white;
}

.btn-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.btn-label {
  font-family: "Ubuntu-Bold", system-ui, sans-serif;
  font-size: 1.1rem;
  color: white;
  margin-bottom: 0.25rem;
}

.btn-description {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
}

.btn-arrow {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s ease;
}

.btn-arrow svg {
  color: white;
}

.cemop-download-btn:hover .btn-arrow {
  transform: translateY(4px);
}

.cemop-download-btn-secondary:hover .btn-arrow {
  transform: translateX(4px);
}

/* Responsive */
@media (max-width: 768px) {
  .cemop-header-card {
    padding: 2rem 1.5rem;
  }

  .cemop-title {
    font-size: 2rem;
  }

  .cemop-subtitle {
    font-size: 1.1rem;
  }

  .cemop-alert-card {
    flex-direction: column;
    text-align: center;
  }

  .alert-icon {
    margin: 0 auto;
  }

  .cemop-buttons-grid {
    grid-template-columns: 1fr;
  }

  .cemop-download-btn {
    flex-direction: column;
    text-align: center;
  }

  .btn-content {
    align-items: center;
  }

  .btn-arrow {
    display: none;
  }
}

/* Animation */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cemop-header-card,
.cemop-alert-card,
.cemop-buttons-grid {
  animation: fadeInUp 0.6s ease-out;
}

.cemop-alert-card {
  animation-delay: 0.1s;
}

.cemop-buttons-grid {
  animation-delay: 0.2s;
}
</style>
